export function HorizontalBars({ items, max }) {
  const peak = max ?? Math.max(1, ...items.map((i) => i.value));
  return (
    <div className="h-bars">
      {items.map((row) => (
        <div key={row.label} className="h-bars__row">
          <span className="h-bars__label" title={row.label}>
            {row.label}
          </span>
          <div className="h-bars__track">
            <div
              className="h-bars__fill"
              style={{ width: `${Math.min(100, (row.value / peak) * 100)}%` }}
            />
          </div>
          <span className="h-bars__pct">{row.display ?? row.value}</span>
        </div>
      ))}
    </div>
  );
}
